/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { Workbox } from 'workbox-window'
import 'babel-polyfill'
import 'isomorphic-fetch'
import App from './layout/App'
import * as Sentry from '@sentry/react'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import store from './store'
import { Provider } from 'react-redux'

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: 'https://e54d8f9340494ec6a5d1ca840ea35f7c:4608c97d18694c2a84d3ee0e973dfc78@sentry2.intdev.exetel.com.au/23'
    })
}

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
ReactDOM.render(
    <BrowserRouter>
        <MuiPickersUtilsProvider utils={MomentUtils}>
            <Provider store={store}>
                <App />
            </Provider>
        </MuiPickersUtilsProvider>
    </BrowserRouter>
    , document.getElementById('root'))

if ('serviceWorker' in navigator) {
    if (process.env.NODE_ENV === 'production') {
        const wb = new Workbox('/service-worker.js')

        if ('BroadcastChannel' in window) {
            const channel = new BroadcastChannel('sw-messages')
            channel.addEventListener('message', event => {
                if (event.data.type === 'HANDLE_FETCH_ERROR') {
                    Sentry.withScope((scope) => {
                        scope.setExtras(event.data.payload)
                        Sentry.captureMessage(event.data.payload.body)
                    })
                }
            })
        }

        wb.register().catch(() => {
            // Catch required to handle error while private browsing in FF
        })
    }
}



// WEBPACK FOOTER //
// ./resources/js/app.js